import { motion } from 'framer-motion';
import { cn } from '../lib/cn';
import { springQuick, tapScale } from '../tokens';

type SectionHeaderProps = {
  title: string;
  action?: { label: string; onClick: () => void };
  className?: string;
};

/**
 * Section label above a card or list. iOS uses systemGray (#8E8E93)
 * for these in both light and dark mode — it reads as chrome, not
 * content, in either theme.
 */
export function SectionHeader({ title, action, className }: SectionHeaderProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-between mb-2 px-1',
        className,
      )}
    >
      <h2 className="text-[13px] font-medium uppercase tracking-[0.05em] text-[#8E8E93]">
        {title}
      </h2>
      {action ? (
        <motion.button
          type="button"
          onClick={action.onClick}
          whileTap={tapScale}
          transition={springQuick}
          className="text-[13px] font-medium text-accent"
        >
          {action.label}
        </motion.button>
      ) : null}
    </div>
  );
}
